// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CSPja","label":"styles_label__2f62M"};